export const getFavoriteOrder = (order, favorite, tableId) => {
  let pos = order[tableId];
  if(favorite.includes(tableId)){
    pos = favorite.indexOf(tableId);
  }
  return pos;
};
